import React from "react";
import { getTagVariantFromLabel, mapMdbBadgeColor } from "./statusUtils";
import "./ui.css";

function Tag({ children, variant, className = "", ...rest }) {
  const resolvedVariant = variant || getTagVariantFromLabel(children) || "neutral";

  const classes = ["oh-tag", `oh-tag--${resolvedVariant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
}

/** Drop-in replacement for MDBBadge */
export function Badge({ color = "secondary", children, className = "", ...rest }) {
  const variant = mapMdbBadgeColor(color);
  const classes = ["oh-tag", `oh-tag--${variant}`, className].filter(Boolean).join(" ");

  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
}

export default Tag;
